import * as X from "react";
import qr, { forwardRef as Br, useContext as Nt, useState as At, useEffect as $t } from "react";
import { ImageDefaultIcon as kt } from "@illa-design/icon";
import { globalColor as Gr, illaPrefix as Jr, applyBoxStyle as It, deleteCssProps as Dt } from "@illa-design/theme";
import { css as cr } from "@emotion/react";
var tr = { exports: {} }, ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pr;
function Ft() {
  if (Pr)
    return ye;
  Pr = 1;
  var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, h) {
    var d, y = {}, N = null, A = null;
    h !== void 0 && (N = "" + h), p.key !== void 0 && (N = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: N, ref: A, props: y, _owner: o.current };
  }
  return ye.Fragment = n, ye.jsx = f, ye.jsxs = f, ye;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Mt() {
  return Nr || (Nr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), N = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), C = Symbol.iterator, g = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = C && t[C] || t[g];
      return typeof s == "function" ? s : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        T("error", t, u);
      }
    }
    function T(t, s, u) {
      {
        var m = b.ReactDebugCurrentFrame, R = m.getStackAddendum();
        R !== "" && (s += "%s", u = u.concat([R]));
        var I = u.map(function(S) {
          return String(S);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, I);
      }
    }
    var k = !1, c = !1, L = !1, $ = !1, Ue = !1, we;
    we = Symbol.for("react.module.reference");
    function qe(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Ue || t === o || t === h || t === d || $ || t === A || k || c || L || typeof t == "object" && t !== null && (t.$$typeof === N || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === we || t.getModuleId !== void 0));
    }
    function Be(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var R = s.displayName || s.name || "";
      return R !== "" ? u + "(" + R + ")" : u;
    }
    function Ce(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Ce(s) + ".Consumer";
          case f:
            var u = t;
            return Ce(u._context) + ".Provider";
          case p:
            return Be(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : B(t.type) || "Memo";
          case N: {
            var R = t, I = R._payload, S = R._init;
            try {
              return B(S(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, Q = 0, Te, Oe, fe, Pe, le, Ne, Ae;
    function $e() {
    }
    $e.__reactDisabledLog = !0;
    function Ge() {
      {
        if (Q === 0) {
          Te = console.log, Oe = console.info, fe = console.warn, Pe = console.error, le = console.group, Ne = console.groupCollapsed, Ae = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: $e,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        Q++;
      }
    }
    function Je() {
      {
        if (Q--, Q === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Te
            }),
            info: H({}, t, {
              value: Oe
            }),
            warn: H({}, t, {
              value: fe
            }),
            error: H({}, t, {
              value: Pe
            }),
            group: H({}, t, {
              value: le
            }),
            groupCollapsed: H({}, t, {
              value: Ne
            }),
            groupEnd: H({}, t, {
              value: Ae
            })
          });
        }
        Q < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = b.ReactCurrentDispatcher, pe;
    function re(t, s, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (R) {
            var m = R.stack.trim().match(/\n( *(at )?)/);
            pe = m && m[1] || "";
          }
        return `
` + pe + t;
      }
    }
    var ve = !1, te;
    {
      var Ke = typeof WeakMap == "function" ? WeakMap : Map;
      te = new Ke();
    }
    function v(t, s) {
      if (!t || ve)
        return "";
      {
        var u = te.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      ve = !0;
      var R = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = de.current, de.current = null, Ge();
      try {
        if (s) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (Z) {
              m = Z;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var _ = Z.stack.split(`
`), W = m.stack.split(`
`), F = _.length - 1, M = W.length - 1; F >= 1 && M >= 0 && _[F] !== W[M]; )
            M--;
          for (; F >= 1 && M >= 0; F--, M--)
            if (_[F] !== W[M]) {
              if (F !== 1 || M !== 1)
                do
                  if (F--, M--, M < 0 || _[F] !== W[M]) {
                    var q = `
` + _[F].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && te.set(t, q), q;
                  }
                while (F >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        ve = !1, de.current = I, Je(), Error.prepareStackTrace = R;
      }
      var oe = t ? t.displayName || t.name : "", Or = oe ? re(oe) : "";
      return typeof t == "function" && te.set(t, Or), Or;
    }
    function he(t, s, u) {
      return v(t, !1);
    }
    function ne(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ee(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ne(t));
      if (typeof t == "string")
        return re(t);
      switch (t) {
        case h:
          return re("Suspense");
        case d:
          return re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return he(t.render);
          case y:
            return ee(t.type, s, u);
          case N: {
            var m = t, R = m._payload, I = m._init;
            try {
              return ee(I(R), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, mr = {}, yr = b.ReactDebugCurrentFrame;
    function Ie(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        yr.setExtraStackFrame(u);
      } else
        yr.setExtraStackFrame(null);
    }
    function ft(t, s, u, m, R) {
      {
        var I = Function.call.bind(ke);
        for (var S in t)
          if (I(t, S)) {
            var _ = void 0;
            try {
              if (typeof t[S] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              _ = t[S](s, S, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              _ = F;
            }
            _ && !(_ instanceof Error) && (Ie(R), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, S, typeof _), Ie(null)), _ instanceof Error && !(_.message in mr) && (mr[_.message] = !0, Ie(R), E("Failed %s type: %s", u, _.message), Ie(null));
          }
      }
    }
    var lt = Array.isArray;
    function He(t) {
      return lt(t);
    }
    function dt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function pt(t) {
      try {
        return Er(t), !1;
      } catch {
        return !0;
      }
    }
    function Er(t) {
      return "" + t;
    }
    function gr(t) {
      if (pt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", dt(t)), Er(t);
    }
    var me = b.ReactCurrentOwner, vt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, br, _r, Ze;
    Ze = {};
    function ht(t) {
      if (ke.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function mt(t) {
      if (ke.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function yt(t, s) {
      if (typeof t.ref == "string" && me.current && s && me.current.stateNode !== s) {
        var u = B(me.current.type);
        Ze[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(me.current.type), t.ref), Ze[u] = !0);
      }
    }
    function Et(t, s) {
      {
        var u = function() {
          br || (br = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          _r || (_r = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var bt = function(t, s, u, m, R, I, S) {
      var _ = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: S,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return _._store = {}, Object.defineProperty(_._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(_, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(_, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.freeze && (Object.freeze(_.props), Object.freeze(_)), _;
    };
    function _t(t, s, u, m, R) {
      {
        var I, S = {}, _ = null, W = null;
        u !== void 0 && (gr(u), _ = "" + u), mt(s) && (gr(s.key), _ = "" + s.key), ht(s) && (W = s.ref, yt(s, R));
        for (I in s)
          ke.call(s, I) && !vt.hasOwnProperty(I) && (S[I] = s[I]);
        if (t && t.defaultProps) {
          var F = t.defaultProps;
          for (I in F)
            S[I] === void 0 && (S[I] = F[I]);
        }
        if (_ || W) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          _ && Et(S, M), W && gt(S, M);
        }
        return bt(t, _, W, R, m, me.current, S);
      }
    }
    var Xe = b.ReactCurrentOwner, Sr = b.ReactDebugCurrentFrame;
    function ae(t) {
      if (t) {
        var s = t._owner, u = ee(t.type, t._source, s ? s.type : null);
        Sr.setExtraStackFrame(u);
      } else
        Sr.setExtraStackFrame(null);
    }
    var Qe;
    Qe = !1;
    function er(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Rr() {
      {
        if (Xe.current) {
          var t = B(Xe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function St(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var xr = {};
    function Rt(t) {
      {
        var s = Rr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function wr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Rt(s);
        if (xr[u])
          return;
        xr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== Xe.current && (m = " It was passed a child from " + B(t._owner.type) + "."), ae(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ae(null);
      }
    }
    function Cr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (He(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            er(m) && wr(m, s);
          }
        else if (er(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var R = D(t);
          if (typeof R == "function" && R !== t.entries)
            for (var I = R.call(t), S; !(S = I.next()).done; )
              er(S.value) && wr(S.value, s);
        }
      }
    }
    function xt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = B(s);
          ft(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !Qe) {
          Qe = !0;
          var R = B(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function wt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ae(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ae(null);
            break;
          }
        }
        t.ref !== null && (ae(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
      }
    }
    function Tr(t, s, u, m, R, I) {
      {
        var S = qe(t);
        if (!S) {
          var _ = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (_ += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = St(R);
          W ? _ += W : _ += Rr();
          var F;
          t === null ? F = "null" : He(t) ? F = "array" : t !== void 0 && t.$$typeof === r ? (F = "<" + (B(t.type) || "Unknown") + " />", _ = " Did you accidentally export a JSX literal instead of a component?") : F = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, _);
        }
        var M = _t(t, s, u, R, I);
        if (M == null)
          return M;
        if (S) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (He(q)) {
                for (var oe = 0; oe < q.length; oe++)
                  Cr(q[oe], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cr(q, t);
        }
        return t === a ? wt(M) : xt(M), M;
      }
    }
    function Ct(t, s, u) {
      return Tr(t, s, u, !0);
    }
    function Tt(t, s, u) {
      return Tr(t, s, u, !1);
    }
    var Ot = Tt, Pt = Ct;
    Ee.Fragment = a, Ee.jsx = Ot, Ee.jsxs = Pt;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? tr.exports = Ft() : tr.exports = Mt();
var Ar = tr.exports;
function jt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Lt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Vt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Lt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = jt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Le = "-moz-", x = "-webkit-", ur = "comm", fr = "rule", lr = "decl", Yt = "@import", Kr = "@keyframes", Wt = "@layer", zt = Math.abs, Ye = String.fromCharCode, Ut = Object.assign;
function qt(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function Hr(e) {
  return e.trim();
}
function Bt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function nr(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function dr(e) {
  return e.length;
}
function De(e, r) {
  return r.push(e), e;
}
function Gt(e, r) {
  return e.map(r).join("");
}
var We = 1, ce = 1, Zr = 0, z = 0, j = 0, ue = "";
function ze(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: We, column: ce, length: f, return: "" };
}
function ge(e, r) {
  return Ut(ze("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Jt() {
  return j;
}
function Kt() {
  return j = z > 0 ? V(ue, --z) : 0, ce--, j === 10 && (ce = 1, We--), j;
}
function U() {
  return j = z < Zr ? V(ue, z++) : 0, ce++, j === 10 && (ce = 1, We++), j;
}
function K() {
  return V(ue, z);
}
function Fe() {
  return z;
}
function xe(e, r) {
  return _e(ue, e, r);
}
function Se(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Xr(e) {
  return We = ce = 1, Zr = J(ue = e), z = 0, [];
}
function Qr(e) {
  return ue = "", e;
}
function Me(e) {
  return Hr(xe(z - 1, ar(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ht(e) {
  for (; (j = K()) && j < 33; )
    U();
  return Se(e) > 2 || Se(j) > 3 ? "" : " ";
}
function Zt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return xe(e, Fe() + (r < 6 && K() == 32 && U() == 32));
}
function ar(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ar(j);
        break;
      case 40:
        e === 41 && ar(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Xt(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + xe(r, z - 1) + "*" + Ye(e === 47 ? e : U());
}
function Qt(e) {
  for (; !Se(K()); )
    U();
  return xe(e, z);
}
function en(e) {
  return Qr(je("", null, null, null, [""], e = Xr(e), 0, [0], e));
}
function je(e, r, n, a, o, i, f, l, p) {
  for (var h = 0, d = 0, y = f, N = 0, A = 0, C = 0, g = 1, D = 1, b = 1, E = 0, T = "", k = o, c = i, L = a, $ = T; D; )
    switch (C = E, E = U()) {
      case 40:
        if (C != 108 && V($, y - 1) == 58) {
          nr($ += w(Me(E), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        $ += Me(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        $ += Ht(C);
        break;
      case 92:
        $ += Zt(Fe() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            De(rn(Xt(U(), Fe()), r, n), p);
            break;
          default:
            $ += "/";
        }
        break;
      case 123 * g:
        l[h++] = J($) * b;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            b == -1 && ($ = w($, /\f/g, "")), A > 0 && J($) - y && De(A > 32 ? kr($ + ";", a, n, y - 1) : kr(w($, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            $ += ";";
          default:
            if (De(L = $r($, r, n, h, d, o, l, T, k = [], c = [], y), i), E === 123)
              if (d === 0)
                je($, r, L, L, k, i, y, l, c);
              else
                switch (N === 99 && V($, 3) === 110 ? 100 : N) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    je(e, L, L, a && De($r(e, L, L, 0, 0, o, l, T, o, k = [], y), c), o, c, y, l, a ? k : c);
                    break;
                  default:
                    je($, L, L, L, [""], c, 0, l, c);
                }
        }
        h = d = A = 0, g = b = 1, T = $ = "", y = f;
        break;
      case 58:
        y = 1 + J($), A = C;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && Kt() == 125)
            continue;
        }
        switch ($ += Ye(E), E * g) {
          case 38:
            b = d > 0 ? 1 : ($ += "\f", -1);
            break;
          case 44:
            l[h++] = (J($) - 1) * b, b = 1;
            break;
          case 64:
            K() === 45 && ($ += Me(U())), N = K(), d = y = J(T = $ += Qt(Fe())), E++;
            break;
          case 45:
            C === 45 && J($) == 2 && (g = 0);
        }
    }
  return i;
}
function $r(e, r, n, a, o, i, f, l, p, h, d) {
  for (var y = o - 1, N = o === 0 ? i : [""], A = dr(N), C = 0, g = 0, D = 0; C < a; ++C)
    for (var b = 0, E = _e(e, y + 1, y = zt(g = f[C])), T = e; b < A; ++b)
      (T = Hr(g > 0 ? N[b] + " " + E : w(E, /&\f/g, N[b]))) && (p[D++] = T);
  return ze(e, r, n, o === 0 ? fr : l, p, h, d);
}
function rn(e, r, n) {
  return ze(e, r, n, ur, Ye(Jt()), _e(e, 2, -2), 0);
}
function kr(e, r, n, a) {
  return ze(e, r, n, lr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function se(e, r) {
  for (var n = "", a = dr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function tn(e, r, n, a) {
  switch (e.type) {
    case Wt:
      if (e.children.length)
        break;
    case Yt:
    case lr:
      return e.return = e.return || e.value;
    case ur:
      return "";
    case Kr:
      return e.return = e.value + "{" + se(e.children, a) + "}";
    case fr:
      e.value = e.props.join(",");
  }
  return J(n = se(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function nn(e) {
  var r = dr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function an(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function on(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !Se(i); )
    U();
  return xe(r, z);
}, cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Se(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += sn(z - 1, n, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ye(o);
    }
  while (o = U());
  return r;
}, un = function(r, n) {
  return Qr(cn(Xr(r), n));
}, Ir = /* @__PURE__ */ new WeakMap(), fn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Ir.get(a)) && !o) {
      Ir.set(r, !0);
      for (var i = [], f = un(n, i), l = a.props, p = 0, h = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, h++)
          r.props[h] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, ln = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, dn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", pn = function(r) {
  return r.type === "comm" && r.children.indexOf(dn) > -1;
}, vn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var h = l[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (pn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, et = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, hn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!et(n[a]))
      return !0;
  return !1;
}, Dr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, mn = function(r, n, a) {
  et(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Dr(r)) : hn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Dr(r)));
};
function rt(e, r) {
  switch (qt(e, r)) {
    case 5103:
      return x + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return x + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return x + e + Le + e + Y + e + e;
    case 6828:
    case 4268:
      return x + e + Y + e + e;
    case 6165:
      return x + e + Y + "flex-" + e + e;
    case 5187:
      return x + e + w(e, /(\w+).+(:[^]+)/, x + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return x + e + Y + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return x + e + Y + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return x + e + Y + w(e, "shrink", "negative") + e;
    case 5292:
      return x + e + Y + w(e, "basis", "preferred-size") + e;
    case 6060:
      return x + "box-" + w(e, "-grow", "") + x + e + Y + w(e, "grow", "positive") + e;
    case 4554:
      return x + w(e, /([^-])(transform)/g, "$1" + x + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, x + "$1"), /(image-set)/, x + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, x + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, x + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + x + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, x + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + x + "$2-$3$1" + Le + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~nr(e, "stretch") ? rt(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, J(e) - 3 - (~nr(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + x) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + x + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + x + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return x + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return x + e + Y + e + e;
  }
  return e;
}
var yn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case lr:
        r.return = rt(r.value, r.length);
        break;
      case Kr:
        return se([ge(r, {
          value: w(r.value, "@", "@" + x)
        })], o);
      case fr:
        if (r.length)
          return Gt(r.props, function(i) {
            switch (Bt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return se([ge(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Le + "$1")]
                })], o);
              case "::placeholder":
                return se([ge(r, {
                  props: [w(i, /:(plac\w+)/, ":" + x + "input-$1")]
                }), ge(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Le + "$1")]
                }), ge(r, {
                  props: [w(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, En = [yn], gn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var D = g.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || En;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var D = g.getAttribute("data-emotion").split(" "), b = 1; b < D.length; b++)
        i[D[b]] = !0;
      l.push(g);
    }
  );
  var p, h = [fn, ln];
  process.env.NODE_ENV !== "production" && h.push(vn({
    get compat() {
      return C.compat;
    }
  }), mn);
  {
    var d, y = [tn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== ur && d.insert(g.value + "{}"));
    } : an(function(g) {
      d.insert(g);
    })], N = nn(h.concat(o, y)), A = function(D) {
      return se(en(D), N);
    };
    p = function(D, b, E, T) {
      d = E, process.env.NODE_ENV !== "production" && b.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + b.map);
        }
      }), A(D ? D + "{" + b.styles + "}" : b.styles), T && (C.inserted[b.name] = !0);
    };
  }
  var C = {
    key: n,
    sheet: new Vt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return C.sheet.hydrate(l), C;
}, or = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function bn() {
  if (Fr)
    return O;
  Fr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function T(c) {
    if (typeof c == "object" && c !== null) {
      var L = c.$$typeof;
      switch (L) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case C:
                case A:
                case f:
                  return c;
                default:
                  return L;
              }
          }
        case n:
          return L;
      }
    }
  }
  function k(c) {
    return T(c) === h;
  }
  return O.AsyncMode = p, O.ConcurrentMode = h, O.ContextConsumer = l, O.ContextProvider = f, O.Element = r, O.ForwardRef = d, O.Fragment = a, O.Lazy = C, O.Memo = A, O.Portal = n, O.Profiler = i, O.StrictMode = o, O.Suspense = y, O.isAsyncMode = function(c) {
    return k(c) || T(c) === p;
  }, O.isConcurrentMode = k, O.isContextConsumer = function(c) {
    return T(c) === l;
  }, O.isContextProvider = function(c) {
    return T(c) === f;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return T(c) === d;
  }, O.isFragment = function(c) {
    return T(c) === a;
  }, O.isLazy = function(c) {
    return T(c) === C;
  }, O.isMemo = function(c) {
    return T(c) === A;
  }, O.isPortal = function(c) {
    return T(c) === n;
  }, O.isProfiler = function(c) {
    return T(c) === i;
  }, O.isStrictMode = function(c) {
    return T(c) === o;
  }, O.isSuspense = function(c) {
    return T(c) === y;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === N || typeof c == "object" && c !== null && (c.$$typeof === C || c.$$typeof === A || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === D || c.$$typeof === b || c.$$typeof === E || c.$$typeof === g);
  }, O.typeOf = T, O;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function _n() {
  return Mr || (Mr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, N = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, C = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function T(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === N || typeof v == "object" && v !== null && (v.$$typeof === C || v.$$typeof === A || v.$$typeof === f || v.$$typeof === l || v.$$typeof === d || v.$$typeof === D || v.$$typeof === b || v.$$typeof === E || v.$$typeof === g);
    }
    function k(v) {
      if (typeof v == "object" && v !== null) {
        var he = v.$$typeof;
        switch (he) {
          case r:
            var ne = v.type;
            switch (ne) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ne;
              default:
                var ee = ne && ne.$$typeof;
                switch (ee) {
                  case l:
                  case d:
                  case C:
                  case A:
                  case f:
                    return ee;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var c = p, L = h, $ = l, Ue = f, we = r, qe = d, Be = a, Ce = C, B = A, H = n, Q = i, Te = o, Oe = y, fe = !1;
    function Pe(v) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(v) || k(v) === p;
    }
    function le(v) {
      return k(v) === h;
    }
    function Ne(v) {
      return k(v) === l;
    }
    function Ae(v) {
      return k(v) === f;
    }
    function $e(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Ge(v) {
      return k(v) === d;
    }
    function Je(v) {
      return k(v) === a;
    }
    function de(v) {
      return k(v) === C;
    }
    function pe(v) {
      return k(v) === A;
    }
    function re(v) {
      return k(v) === n;
    }
    function ve(v) {
      return k(v) === i;
    }
    function te(v) {
      return k(v) === o;
    }
    function Ke(v) {
      return k(v) === y;
    }
    P.AsyncMode = c, P.ConcurrentMode = L, P.ContextConsumer = $, P.ContextProvider = Ue, P.Element = we, P.ForwardRef = qe, P.Fragment = Be, P.Lazy = Ce, P.Memo = B, P.Portal = H, P.Profiler = Q, P.StrictMode = Te, P.Suspense = Oe, P.isAsyncMode = Pe, P.isConcurrentMode = le, P.isContextConsumer = Ne, P.isContextProvider = Ae, P.isElement = $e, P.isForwardRef = Ge, P.isFragment = Je, P.isLazy = de, P.isMemo = pe, P.isPortal = re, P.isProfiler = ve, P.isStrictMode = te, P.isSuspense = Ke, P.isValidElementType = T, P.typeOf = k;
  }()), P;
}
process.env.NODE_ENV === "production" ? or.exports = bn() : or.exports = _n();
var Sn = or.exports, tt = Sn, Rn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, xn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nt = {};
nt[tt.ForwardRef] = Rn;
nt[tt.Memo] = xn;
var wn = !0;
function Cn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var at = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  wn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Tn = function(r, n, a) {
  at(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function On(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Pn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Nn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", An = /[A-Z]|^ms/g, ot = /_EMO_([^_]+?)_([^]*?)_EMO_/g, pr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, rr = /* @__PURE__ */ on(function(e) {
  return pr(e) ? e : e.replace(An, "-$&").toLowerCase();
}), Ve = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ot, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Pn[r] !== 1 && !pr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var $n = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kn = ["normal", "none", "initial", "inherit", "unset"], In = Ve, Dn = /^-ms-/, Fn = /-(.)/g, Vr = {};
  Ve = function(r, n) {
    if (r === "content" && (typeof n != "string" || kn.indexOf(n) === -1 && !$n.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = In(r, n);
    return a !== "" && !pr(r) && r.indexOf("-") !== -1 && Vr[r] === void 0 && (Vr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Dn, "ms-").replace(Fn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var it = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Re(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(it);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Mn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, f = n(e);
        return G = i, Re(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(ot, function(d, y, N) {
          var A = "animation" + l.length;
          return l.push("const " + A + " = keyframes`" + N.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Mn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Re(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Lr(f) && (a += rr(i) + ":" + Ve(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(it);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Lr(f[l]) && (a += rr(i) + ":" + Ve(i, f[l]) + ";");
        else {
          var p = Re(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += rr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Nn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Yr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, st;
process.env.NODE_ENV !== "production" && (st = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Wr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Re(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(jr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += Re(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(jr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(st, function(N) {
    return p = N, "";
  })), Yr.lastIndex = 0;
  for (var h = "", d; (d = Yr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = On(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, jn = function(r) {
  return r();
}, Ln = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Vn = Ln || jn, vr = {}.hasOwnProperty, hr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ gn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (hr.displayName = "EmotionCacheContext");
hr.Provider;
var Yn = function(r) {
  return /* @__PURE__ */ Br(function(n, a) {
    var o = Nt(hr);
    return r(n, o, a);
  });
}, ct = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ct.displayName = "EmotionThemeContext");
var zr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Wn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return zr(n[1]);
}, zn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Un = function(r) {
  return r.replace(/\$/g, "-");
}, qn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Wn(n[a]);
      if (o) {
        if (zn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Un(o);
      }
    }
}, ir = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", sr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Bn = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    vr.call(n, o) && (a[o] = n[o]);
  if (a[ir] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = qn(new Error().stack);
    i && (a[sr] = i);
  }
  return a;
}, Gn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return at(n, a, o), Vn(function() {
    return Tn(n, a, o);
  }), null;
}, ut = /* @__PURE__ */ Yn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[ir], i = [a], f = "";
  typeof e.className == "string" ? f = Cn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = Wr(i, void 0, X.useContext(ct));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[sr];
    p && (l = Wr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var h = {};
  for (var d in e)
    vr.call(e, d) && d !== "css" && d !== ir && (process.env.NODE_ENV === "production" || d !== sr) && (h[d] = e[d]);
  return h.ref = n, h.className = f, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Gn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionCssPropInternal");
var Jn = ut;
function be(e, r, n) {
  return vr.call(r, "css") ? Ar.jsx(Jn, Bn(e, r), n) : Ar.jsx(e, r, n);
}
function Ur(e, r) {
  return cr`
    object-fit: ${e};
    border-radius: ${r};
  `;
}
function Kn(e, r, n) {
  return cr`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${Gr(`--${Jr}-grayBlue-09`)};
    border-radius: ${n};
    width: ${e};
    height: ${r};
  `;
}
const Hn = cr`
  vertical-align: middle;
  display: inline-flex;
`;
var ie;
(function(e) {
  e[e.Loading = 0] = "Loading", e[e.Loaded = 1] = "Loaded", e[e.Error = 2] = "Error";
})(ie || (ie = {}));
const Zn = Br((e, r) => {
  const {
    // origin
    src: n = "",
    width: a = "100px",
    height: o = "100px",
    alt: i = "",
    // custom
    objectFit: f = "cover",
    fallback: l = be(kt, { color: Gr(`--${Jr}-blackAlpha-06`) }),
    fallbackSrc: p = "",
    radius: h = "4px",
    // img
    crossOrigin: d,
    decoding: y,
    loading: N,
    referrerPolicy: A,
    sizes: C,
    srcSet: g,
    useMap: D,
    draggable: b = !0,
    ...E
  } = e, [T, k] = At();
  return $t(() => {
    k(ie.Loading);
  }, [n]), be("div", { css: [Hn, It(e)], ref: r, ...Dt(E), children: n && n.length != 0 && T != ie.Error ? be("img", { css: Ur(f, h), alt: i, src: n, width: a, height: o, onError: (c) => {
    k(ie.Error), e.onError != null && e.onError(c);
  }, onLoad: (c) => {
    k(ie.Loaded), e.onLoad != null && e.onLoad(c);
  }, crossOrigin: d, decoding: y, loading: N, referrerPolicy: A, sizes: C, srcSet: g, useMap: D, draggable: b }) : p && p.length != 0 ? be("img", { css: Ur(f, h), alt: i, src: p, width: a, height: o, crossOrigin: d, decoding: y, loading: N, referrerPolicy: A, sizes: C, srcSet: g, useMap: D, draggable: b }) : be("div", { css: Kn(a, o, h), children: l }) });
});
Zn.displayName = "Image";
export {
  Zn as Image
};
//# sourceMappingURL=index.js.map
